<template>
	<div class="parent" style="height:calc(100vh - 50px);">

		<div>
			<div style="width:65%;">
				<div style="height:30px; padding:15px; font-size:16px;" id="jobInfoText"></div>
				<hr style="margin-left:25px;margin-right:25px;"/>
				<layout-7
					v-if="perms.includes('38')"
					:id=pageid2
					:term=term
					:title="'Report Times'"
					:edit_types="[null,'DateTime','DateTime','Value','TextArea',null]"
					:edit_perm="'39'"
					:isAdd="true"
					style="width:100%; height:calc(100vh - 150px); float:left;">
				</layout-7>
			</div>

			<div class="scroll" style="width:30%; height:calc(100vh - 150px); float:right;">
				<document
					ref="doc"
					:dir="'doc_'+parseInt(term)+'.jpg'"
					:doc_id="term">
				</document>
			</div>
		</div>

		<div class="nav-bar">
			<div>
				<button v-if="perms.includes('17')" v-on:click="button('Edit')">Edit Document</button>
				<button v-if="perms.includes('105')" v-on:click="button('Edit Service Report')">Edit Service Report</button>
			</div>
		</div>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			perms:[],
			pageid:PAGES.DOCUMENTS_PAGE,
			pageid2:PAGES.EDIT_REPORT_TIMES_PAGE,
			pageid3:PAGES.DOCUMENT_JOB_INFO,
		}
	},
	async created () {
		this.perms = api.getPerms();
		this.getJobData()
	},
	methods:{
		async button (name){
			api.postData(
				{
					type:"button",
					data:{
						pageid:this.pageid,
						buttonname:name,
					}
				}
			).then((res) => {
				if(res.data.data.to!=null) {
					if(res.data.data.useterm) {
						router.push('/'+res.data.data.to+'?q='+this.term);
					} else {
						router.push('/'+res.data.data.to);
					}
				}
			});
		},
		getJobData(){
			api.postData(
				{
					type:"search",
					data:{
						pageid:this.pageid3,
						data:[
							this.term
						],
					}
				}
			).then((res) => {
				var text = ""
				for(var i = 0;i<res.data.data.column_names.length;i++){
					text+="<div style='float:left; height:30px'>"
					text+="<b>"+res.data.data.column_names[i]+":</b> "
					if(i==0){
						text+="<p style='float:right; height:30px;'>"+res.data.data.column_data[0][i]+"</p>"
					}else if(i==1){
						text+="<a href='/#/0304?q="+res.data.data.column_data[0][i]+"'>"+res.data.data.column_data[0][i]+"</a>"
					}else{
						text+=res.data.data.column_data[0][i]
					}
					text+="&emsp;</div>"
				}
				document.getElementById("jobInfoText").innerHTML = text;
			});
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/view/View_Documents.vue